import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.636 19.364a9 9 0 1 1 12.728 0","key":"svg-0"}],["path",{"d":"M16 9l-4 4","key":"svg-1"}]]

/**
 * IconBrandSpeedtest
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtc3BlZWR0ZXN0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01LjYzNiAxOS4zNjRhOSA5IDAgMSAxIDEyLjcyOCAwIiAvPgogIDxwYXRoIGQ9Ik0xNiA5bC00IDQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-speedtest
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandSpeedtest = createReactComponent('outline', 'brand-speedtest', 'BrandSpeedtest', __iconNode);

export default IconBrandSpeedtest;